<template>
  <component
    :is="tag"
    v-bind="componentProps"
    :class="['base-btn', variant, `size-${size}`, { full }]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'outline',
    },
    to: {
      type: [String, Object],
      default: undefined,
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    rel: {
      type: String,
      default: '',
    },
    full: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    componentProps() {
      if (this.tag === 'router-link') {
        return { to: this.to };
      }
      if (this.tag === 'a') {
        return {
          href: this.href,
          target: this.target || undefined,
          rel: this.rel || undefined,
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.base-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 4px;
  border: 1px solid transparent;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 200ms cubic-bezier(0.02, 0.01, 0.47, 1),
    background-color 200ms cubic-bezier(0.02, 0.01, 0.47, 1),
    color 200ms cubic-bezier(0.02, 0.01, 0.47, 1);

  &.full {
    width: 100%;
  }

  &.size-hero {
    width: 100%;
    max-width: 250px;
    height: 50px;
    padding: 10px 24px;
    box-sizing: border-box;
  }

  &.outline {
    background: #ffffff;
    border-color: #a7aeb1;
    color: #212121;

    &:hover,
    &:active {
      border-color: #74787a;
      background: #f7f9fa;
    }
  }

  &.dark {
    background: #212121;
    border-color: #212121;
    color: #ffffff;

    &:hover,
    &:active {
      background: #303233;
      border-color: #303233;
    }
  }
}
</style>
